import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { getCommercialStructureData } from 'services/app/commercialStructure'
import type { Office } from 'services/app/commercialStructure/interfaces'
import type { AppThunk } from 'store/store'

type InitialStateType = {
  loadingStructure: boolean
  comercialStructure: Office[]
}

const initialState: InitialStateType = {
  comercialStructure: [] as Office[],
  loadingStructure: false,
}

const management = createSlice({
  initialState,
  name: 'management',
  reducers: {
    setComercialStructure(state, action: PayloadAction<Office[]>) {
      state.comercialStructure = action.payload
    },
    setLoadingStructure(state, action: PayloadAction<boolean>) {
      state.loadingStructure = action.payload
    },
  },
})

export const { setLoadingStructure, setComercialStructure } = management.actions

export const managementContext = management.reducer

export const getComercialStructure = (): AppThunk => async (dispatch) => {
  dispatch(setLoadingStructure(true))

  try {
    const structure = await getCommercialStructureData(0)

    dispatch(setComercialStructure(structure))
  } catch (error) {
    toast.error('Erro ao carregar estrutura comercial.')
  } finally {
    dispatch(setLoadingStructure(false))
  }
}
